// Beslist of een ingelogde sessie een "wees" is: een auth uid zonder rij in
// users, admin_users én support_users. Alleen dan mag AuthContext de sessie
// uitloggen; bij een query-fout weten we het niet zeker en blijven we van de
// sessie af (anders logt een netwerk-hikje iedereen uit).
//
// Context: zonder deze guard ontstaat bij een wees-sessie een navigatieloop
// tussen /dashboard en /login, die Firefox afkapt met "The operation is
// insecure" (user_errors bd93369c, 2026-07-11).

export interface RowLookupResult {
  data: unknown | null;
  error: unknown | null;
}

export function isConfirmedOrphanSession(
  adminResult: RowLookupResult,
  supportResult: RowLookupResult,
): boolean {
  return (
    !adminResult.error && !adminResult.data &&
    !supportResult.error && !supportResult.data
  );
}
